import React, { useEffect } from "react";
import "../Css/Home.css";
// import Typewriter from "typewriter-effect";
import Markquee from "./Markquee";

// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';

import { NavLink } from "react-router-dom";
// import computer from '../Video/stock-footage-abstract-pulsing-ring-motion-graphic-element-perfect-for-background-or-logo-placement-particle.webm';
// import Slider from "./Slider";
// import { FcApproval } from "react-icons/fc";
import Typewriter from "typewriter-effect";
import Footer from "./Footer";
import stone from "../Components/image/stone.png";
import Homepic from "../Components/image/contactimage.png";
import friendlyparty from "../Components/image/friendly-partners-handshaking-group-meeting-thanking-successful-teamwork.jpg";
import "./image/logo2.png";
import oneuser from "../Components/image/oneuser.png";
import building from "../Components/image/building.png";
import lightroom from "../Components/image/empty-yellow-room-interior-design-with-ceiling-lamps.jpg";
import book1 from "../Components/image/book1.png";
import book2 from "../Components/image/book2.png";
import book3 from "../Components/image/book3.png";
import book4 from "../Components/image/book4.png";
import { motion, useScroll } from "framer-motion";
import Aos from "aos";
import "aos/dist/aos.css";

function Home() {
  useEffect(() => {
    document.title = "Home";
  });
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  const { scrollYProgress } = useScroll();
  const Containervarients = {
    Hidden: {
      opacity: 0.5,
      x: "-10vw",
    },
    visible: {
      opacity: 1,
      x: 0,
    },
    Transtion: {
      type: "spring",

      stiffness: 1500,
    },
  };
  return (
    <div id="main1" className="container-fluid">
      <motion.div
        style={{
          scaleX: scrollYProgress,
          position: "fixed",
          top: 0,

          right: 0,
          left: 0,
          height: 4,
          transformOrigin: "0%",
          background: "red",
        }}
      />

      <div id="p1" className="row">
        <motion.div
          className="col m-1"
          id="colupper"
          variants={Containervarients}
          initial="Hidden"
          animate="visible"
          transition="Transtion"
        >
          <span id="p1text" className="p-5">
            <Typewriter
              onInit={(typewriter) => {
                typewriter

                  .typeString("Hii i'm Montu kharb")

                  .pauseFor(1000)
                  .deleteAll()
                  .typeString(
                    " The digital path is a journey that never ends, <br/>  filled with endless opportunities for <br/> growth and learning.  "
                  )

                  .start();
              }}
            />
          </span>
        </motion.div>
        <div className="row">
          <motion.div
            className="col-3"
            id="blankbox"
            variants={Containervarients}
            initial="Hidden"
            animate="visible"
            transition="Transtion"
          ></motion.div>
        </div>
      </div>

      <div id="p2" className="row">
        <div
          className="col-5"
          id="p2col1"
          // data-aos="zoom-in"
        >
          <img
            src={stone}
            alt="Fell_of_proud"
            title="Symbol of powerful"
            id="stonepic"
          />
        </div>
        <div className="col" id="p2col2">
          <div
            className="row"
            id="brand"
            // data-aos="zoom-in"
          >
            <h1 id="boldtext" className="p-4">
              Leading Brands in a <br /> Digital World
            </h1>
            <p id="smalltext">
              In an era where everything changes at lightning speed, we lead
              brands into a digital world. We help brands take advantage of
              these challenges.
            </p>
          </div>
          <div className="row" id="basement">
            <div className="col" id="aboutme">
              <h1 id="boldtext2" className="p-4">
                About Us
              </h1>
              <p id="smalltext2">
                The key is to reframe your international target markets and come
                up with creative, durable solutions that will take your brand to
                the next level.
                <br />
                Our drive is that we believe you can do better.
              </p>
            </div>
            <div className="col" id="ourclient">
              <p id="smalltext3">
                Our clients include Google, VodafoneZiggo and Philips. We have
                been awarded internationally over the years and were chosen nº1
                in the Emerce Top 100 Agencies in 2017.
                <br />
                <NavLink id="" to="/Readmore">
                  Read more
                </NavLink>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="row" id="fast">
        <div id="blankbox2" data-aos="fade-up"></div>
        <div className="col-7" id="fasttext">
          <div className="row">
            <div className="col-6" id="fasttextchild" data-aos="zoom-in">
              <h1>Fast Moving Consumer Goods</h1>
              <p>
                Obsessed with creative design. We navigate through different
                galaxies: web design, graphic identity, interactive design,
                keynotes, prints and GIF & illustrations. We’re constantly
                looking for innovative ways to fit your expectations and beyond.
              </p>
              <p>
                Creating new products can be easy with such curiosity and love
                for new technologies. That’s why our team has begun to develop
                this side. We’ve been developing new tech products, marketing
                applications for every side of the Digital Universe. At first
                we’ve developed those projects for ourselve, we are now
                incubating projects for entrepreneurs too.
              </p>
              <NavLink id="" to="/Readmore">
                Read more
              </NavLink>
            </div>
          </div>
        </div>
        <div className="col-3" id="fastpic1" data-aos="zoom-in">
          <img src={Homepic} alt="Designpicture" title="Student-picture" />
        </div>
        <div
          className="col-4"
          id="fastpick1child"
          // data-aos="zoom-out"
        >
          <img src={friendlyparty} alt="employee_pic" title="employee-pic" />
        </div>

        <div className="row">
          <div className="col-12" id="fastpic3">
            <div className="row">
              <div className="col-2" id="blankbox3" data-aos="zoom-in"></div>
              <div className="col-3" id="fastpic5" data-aos="fade-down">
                <img src={building} alt="buildingpic" title="office" />
              </div>
              <div className="row">
                <div className="col-5" id="goal" data-aos="flip-right">
                  <h1>Our Goal</h1>
                  <p>
                    Obsessed with creative design. We navigate through different
                    galaxies: web design, graphic identity, interactive design,
                    keynotes, prints and GIF & illustrations. We’re constantly
                    looking for innovative ways to fit your expectations and
                    beyond.
                  </p>
                  <NavLink id="" to="/Readmore">
                    Read more
                  </NavLink>
                </div>
              </div>
            </div>
            <div className="col-4" id="fastpic4" data-aos="zoom-in">
              <div className="row">
                <div className="col-10" id="mission">
                  <h1 id="missionbold">Our Mission</h1>
                  <p id="missionsmall">
                    Our secret informer improves human & droid relationship by
                    analysing your user’s behavior. A custom strategy coupling a
                    plethora of tools is designed to achieve our clients’ goals.
                    <NavLink id="" to="/Readmore">
                      Read more
                    </NavLink>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row" id="ourservices">
        <div className="row">
          <div
            className="col-4"
            id="lightroom"
            data-aos-anchor-placement="center-center"
          >
            <img src={lightroom} alt="room" title="light room" />
          </div>
          <div
            className="col-3"
            id="user"
            data-aos-anchor-placement="center-center"
          >
            <img src={oneuser} alt="user" title="user" />
          </div>
        </div>
        <div className="row" id="ourservicetextrow">
          <div
            className="col-5"
            id="ourservicetext"
            // data-aos="zoom-out"
          >
            <h1>Our Services</h1>
            <p>
              Creating new products can be easy with such curiosity and love for
              new technologies. That’s why our team has begun to develop this
              side. We’ve been developing new tech products, marketing
              applications for every side of the Digital Universe. At first
              we’ve developed those projects for ourselve, we are now incubating
              projects for entrepreneurs too.
              <NavLink id="" to="/Readmore">
                Read more
              </NavLink>
            </p>
          </div>
          <div className="col-2" id="blankbox4" data-aos="flip-left"></div>
        </div>
      </div>
      <div className="row" id="booksrow">
        <div
          className="col-3"
          id="bookno1"
          data-aos-anchor-placement="center-center"
        >
          <img src={book1} alt="books" title="notebook" />
        </div>
        <div
          className="col-3"
          id="bookno2"
          data-aos-anchor-placement="center-center"
        >
          <img src={book2} alt="books" title="notebook" />
        </div>
        <div
          className="col-3"
          id="bookno3"
          data-aos-anchor-placement="center-center"
        >
          <img src={book3} alt="books" title="notebook" />
        </div>
        <div
          className="col-3"
          id="bookno4"
          data-aos-anchor-placement="center-center"
        >
          <img src={book4} alt="books" title="notebook" />
        </div>
      </div>

      <div className="container-fluid" id="otherdiv">
        <div className="row h-100">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3490.259227765934!2d76.74133427615301!3d28.979688468230236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d97be7c6bb65f%3A0xd5fb0b82177a915a!2sMontu%20kharb!5e0!3m2!1sen!2sin!4v1682676272494!5m2!1sen!2sin "
            loading="lazy"
            title="Location our office"
          />
        </div>
        <div className="row" data-aos="zoom-in">
          <Markquee />
        </div>
      </div>
      <div className="row">
        <Footer />
      </div>
    </div>
  );
}
export default Home;
